import Immutable from 'seamless-immutable'
import { get, snakeCase } from 'lodash'

import * as accountActions from 'reduxBits/account/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  searchResultCountPreview: {
    isFetching: false,
    searchTotal: 0,
    previousSearchTotal: 0,
    error: false,
  },
  stores: {
    isFetching: false,
    error: false,
    errorId: null,
    stores: [],
    totalCount: 0,
    totalPageCount: 0,
    firstFetch: true,
  },
  store: {
    isFetching: false,
    error: false,
    errorId: null,
    data: null,
  },
  searchResults: {
    error: false,
    errorId: null,
    isFetching: false,
    ads: [],
    inventory: {},
    nextScrollId: null,
    searchTotal: 0,
    querySignature: '',
    query: null,
    firstFetch: true,
    totalPageCount: 0,
    breadcrumbs: [],
    gallery: [],
    searchTitle: '',
  },
  shippingAds: {
    ads: [],
    category: '',
    nextScrollId: null,
    totalShippingAdsCount: 0,
  },
  requestedAd: {
    isFetching: true,
    error: false,
    errorId: null,
    ad: null,
    inventory: {},
    breadcrumbs: [],
  },
  supportedBlocketPaketetCategories: [],
  acFeedback: undefined,
  isAdReplyOpen: false,
  sendMessageImageType: '',
  numAdsPerPage: 40,
})

const modCarfaxPartner = (partner) => {
  if (partner.id === 'carfax' && partner.actionUrl) {
    const _partner = {
      ...partner,
      link: {
        url: partner.actionUrl,
        label: partner.linkText || partner.label,
      },
      icon:
        'https://images.ctfassets.net/rvdf5xmxjruf/4ZH3POIYcnTNIL27Nahgzp/92f30878dea619022b81b16179c4dcd4/history.svg',
    }
    return _partner
  }
  return partner
}

const classified = (state = initialState, { type, payload, error }) => {
  let inventory
  let partnerPlacements
  switch (type) {
    case actions.REQUEST_STORES:
      return state.set('stores', {
        ...initialState.store,
        isFetching: true,
        error: false,
        errorId: null,
        firstFetch: false,
      })
    case actions.RECEIVE_STORES:
      if (error) {
        return state.set('stores', {
          ...initialState.stores,
          isFetching: false,
          error: true,
          errorId: get(payload, 'content.error', null),
        })
      }

      return state.set('stores', {
        ...state.stores,
        ...payload,
        error: false,
        errorId: null,
        isFetching: false,
      })
    case actions.REQUEST_STORE:
      return state.set('store', {
        ...initialState.store,
        isFetching: true,
        error: false,
        errorId: null,
      })
    case actions.RECEIVE_STORE:
      if (error) {
        return state.set('store', {
          ...initialState.store,
          isFetching: false,
          error: true,
          errorId: get(payload, 'content.error', null),
        })
      }

      return state.set('store', {
        ...state.store,
        error: false,
        errorId: null,
        isFetching: false,
        data: payload,
      })
    case actions.REQUEST_SEARCH_TOTAL:
      return state.set('searchResultCountPreview', {
        ...state.searchResultCountPreview,
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_SEARCH_TOTAL:
      if (error) {
        return state.set('searchResultCountPreview', {
          ...state.searchResultCountPreview,
          error: true,
          isFetching: false,
          searchTotal: 0,
          previousSearchTotal: state.searchResultCountPreview.searchTotal,
        })
      }

      return state.set('searchResultCountPreview', {
        ...state.searchResultCountPreview,
        error: false,
        isFetching: false,
        searchTotal: parseInt(payload.searchTotal, 10),
        previousSearchTotal: state.searchResultCountPreview.searchTotal,
      })
    case actions.REQUEST_ADS:
      return state.set('searchResults', {
        ...state.searchResults,
        isFetching: true,
        error: false,
        errorId: null,
        firstFetch: false,
      })
    case actions.RECEIVE_ADS:
      if (error) {
        return state.set('searchResults', {
          ...state.searchResults,
          isFetching: false,
          error: true,
          errorDescription: get(payload, 'textOrJson.error_description', null),
          errorId: snakeCase(get(payload, 'textOrJson.error', null)),
        })
      }
      return state
        .set('searchResults', {
          ...state.searchResults,
          ...payload,
          isFetching: false,
          error: false,
          errorId: null,
        })
        .set('acFeedback', null)
        .set('searchResultCountPreview', {
          error: false,
          isFetching: false,
          searchTotal: payload.searchTotal,
          previousSearchTotal: state.searchResultCountPreview.searchTotal,
        })
    case actions.CLEAR_SHIPPING_ADS:
      return state.set('shippingAds', {
        ...initialState.shippingAds,
      })
    case actions.REQUEST_SHIPPING_ADS:
      return state.set('shippingAds', {
        ...state.shippingAds,
        isFetching: true,
        error: false,
        errorId: null,
      })
    case actions.RECEIVE_SHIPPING_ADS:
      if (error) {
        return state.set('shippingAds', {
          ...state.shippingAds,
          isFetching: false,
          error: true,
          errorId: get(payload, 'content.error', null),
        })
      }

      return state.set('shippingAds', {
        ...state.shippingAds,
        ...payload,
        error: false,
        errorId: null,
        isFetching: false,
      })
    case actions.CLEAR_ADS:
      return state.set('searchResults', {
        ...initialState.searchResults,
      })
    case actions.REQUEST_AD:
      return state.setIn(['requestedAd', 'isFetching'], true)
    case actions.RECEIVE_AD:
      if (error) {
        return state.merge({
          requestedAd: {
            error: true,
            isFetching: false,
            errorDescription: get(payload, 'textOrJson.error_description', null),
            errorId: snakeCase(get(payload, 'textOrJson.error', null)),
          },
        })
      }

      inventory = get(payload, '_raw.inventory', {})
      partnerPlacements = get(payload, 'data.partnerPlacements')

      if (partnerPlacements) {
        payload.data.partnerPlacements = payload.data.partnerPlacements.map((partner) => {
          return modCarfaxPartner(partner)
        })
      }

      inventory.placements = get(inventory, 'placements', []).map((placement) => {
        if (placement.type === 'safe_purchase') {
          if (!get(placement, 'safe_purchase.partners')) {
            return placement
          }

          // Carfax, add to safe purchase partners to make it work with ContentfulSafePurchase
          if (partnerPlacements) {
            placement.safe_purchase.partners = partnerPlacements
              .filter((partner) => partner.id === 'carfax')
              .concat(placement.safe_purchase.partners)
          }

          placement.safe_purchase.partners = placement.safe_purchase.partners.map((partner) => {
            partner = modCarfaxPartner(partner)
            return partner
          })
        }
        return placement
      })

      return state.merge({
        requestedAd: {
          isFetching: false,
          ad: payload.data,
          inventory,
          breadcrumbs: get(payload, 'breadcrumbs'),
        },
      })
    case actions.CLEAR_AD:
      return state.set('requestedAd', { ...initialState.requestedAd })

    case actions.SET_AD_REPLY_VISIBILITY:
      return state.set('isAdReplyOpen', payload)
    case actions.RECEIVE_SEND_MESSAGE_IMAGE_TYPE:
      return state.set('sendMessageImageType', payload.type)

    case accountActions.RECEIVE_CREATE_SAVED_AD:
      if (error) {
        return state
      }
      if (payload.adId === get(state, 'requestedAd.ad.adId')) {
        return state.setIn(['requestedAd', 'ad', 'saved'], true)
      }
      return state
    case accountActions.RECEIVE_DELETE_SAVED_AD:
      if (payload.adId === get(state, 'requestedAd.ad.adId')) {
        return state.setIn(['requestedAd', 'ad', 'saved'], false)
      }
      return state
    case accountActions.RECEIVE_CREATE_AD_WATCH:
      if (payload.error) {
        return state
      }
      return state
        .setIn(['searchResults', 'searchSaved'], true)
        .setIn(['searchResults', 'adwatchId'], payload.id)
    case accountActions.RECEIVE_DELETE_AD_WATCH:
      return state.setIn(['searchResults', 'searchSaved'], false)

    default:
      return state
  }
}

export default classified
